import { AddLine, Button, Col, Form, MinusCircleIcon, Row, TimePicker } from 'ui';

type P = {
  disabled?: boolean;
  name: string;
};

const ActivityTimes = ({ disabled, name }: P) => (
  <Form.List name={name}>
    {(fields, { add, remove }) => (
      <>
        {fields.map((field, index) => (
          <Form.Item<number> className="periodicity__times" key={field.key} required={false}>
            <Row gutter="xs">
              <Col flex="1">
                <Form.Item<number>
                  {...field}
                  hideLabel={index > 0}
                  label="Time"
                  name={[field.name, 'time']}
                  rules={[{ required: true }]}
                >
                  <TimePicker disabled={disabled} fullWidth />
                </Form.Item>
              </Col>
              {disabled ? null : (
                <Col alignItems="flexEnd">
                  <Button
                    icon={<MinusCircleIcon />}
                    onClick={() => {
                      remove(field.name);
                    }}
                    size="large"
                    type="text"
                  />
                </Col>
              )}
            </Row>
          </Form.Item>
        ))}
        {disabled ? null : (
          // eslint-disable-next-line no-restricted-syntax -- TODO: check if this make sense
          <Form.Item hideLabel={fields.length > 0} label="Time">
            <Button
              icon={<AddLine />}
              onClick={() => {
                add();
              }}
              size="large"
              type="secondary"
            >
              Add new time
            </Button>
          </Form.Item>
        )}
      </>
    )}
  </Form.List>
);

export default ActivityTimes;
